import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Twitter, Youtube } from 'lucide-react';
import { useSite } from '../../context/SiteContext';

const Footer = () => {
  const { siteData } = useSite();
  const socialMedia = siteData.config?.socialMedia || {};

  return (
    <footer className="bg-[#FFFFFE] py-16 border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Logo & About */}
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="inline-block mb-4">
              <img 
                src="https://res.cloudinary.com/dglumvmjs/image/upload/f_auto,q_auto/v1768977323/eden-remedies/eden-logo.png" 
                alt="Eden Remedies natural and organic skincare" 
                className="h-14 w-auto"
                width={145}
                height={56}
              />
            </Link>
            <p className="text-gray-600 text-sm leading-relaxed max-w-sm mt-4">
              Timeless beauty, naturally revealed. We craft luxurious skincare from nature's most potent botanicals.
            </p>
            <div className="flex gap-4 mt-6">
              {socialMedia.instagram && (
                <a href={socialMedia.instagram} target="_blank" rel="noopener noreferrer" className="text-[#2d4a47] hover:opacity-70 transition-opacity" aria-label="Follow us on Instagram">
                  <Instagram size={20} />
                </a>
              )}
              {socialMedia.facebook && (
                <a href={socialMedia.facebook} target="_blank" rel="noopener noreferrer" className="text-[#2d4a47] hover:opacity-70 transition-opacity" aria-label="Follow us on Facebook">
                  <Facebook size={20} />
                </a>
              )}
              {socialMedia.twitter && (
                <a href={socialMedia.twitter} target="_blank" rel="noopener noreferrer" className="text-[#2d4a47] hover:opacity-70 transition-opacity" aria-label="Follow us on Twitter">
                  <Twitter size={20} />
                </a>
              )}
              {socialMedia.youtube && (
                <a href={socialMedia.youtube} target="_blank" rel="noopener noreferrer" className="text-[#2d4a47] hover:opacity-70 transition-opacity" aria-label="Follow us on YouTube">
                  <Youtube size={20} />
                </a>
              )}
              {/* Show placeholder icons if no social media is set */}
              {!socialMedia.instagram && !socialMedia.facebook && !socialMedia.twitter && !socialMedia.youtube && (
                <>
                  <span className="text-gray-300"><Instagram size={20} /></span>
                  <span className="text-gray-300"><Facebook size={20} /></span>
                  <span className="text-gray-300"><Twitter size={20} /></span>
                </>
              )}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-semibold tracking-wider text-[#2d4a47] uppercase mb-4">Shop</h3>
            <ul className="space-y-3">
              <li><Link to="/products" className="text-gray-600 text-sm hover:text-[#2d4a47] transition-colors">All Products</Link></li>
              <li><Link to="/products?new=true" className="text-gray-600 text-sm hover:text-[#2d4a47] transition-colors">New Arrivals</Link></li>
              <li><Link to="/products?sale=true" className="text-gray-600 text-sm hover:text-[#2d4a47] transition-colors">On Sale</Link></li>
            </ul>
          </div>

          {/* Policies */}
          <div>
            <h3 className="text-sm font-semibold tracking-wider text-[#2d4a47] uppercase mb-4">Policies</h3>
            <ul className="space-y-3">
              <li><Link to="/shipping-policy" className="text-gray-600 text-sm hover:text-[#2d4a47] transition-colors">Shipping Policy</Link></li>
              <li><Link to="/returns-policy" className="text-gray-600 text-sm hover:text-[#2d4a47] transition-colors">Returns & Refunds</Link></li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-sm font-semibold tracking-wider text-[#2d4a47] uppercase mb-4">Account</h3>
            <ul className="space-y-3">
              <li><Link to="/account" className="text-gray-600 text-sm hover:text-[#2d4a47] transition-colors">My Account</Link></li>
              <li><Link to="/account/orders" className="text-gray-600 text-sm hover:text-[#2d4a47] transition-colors">Order History</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 mt-12 pt-8">
          <p className="text-gray-500 text-xs text-center">
            © {new Date().getFullYear()} Eden Remedies. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
